import React from 'react';
import styles from './Loader.css';

export default function Loader({ size = '1em', loading = false }) {
  if (loading) {
    return (
      <div className={styles.loader} style={{ height: size, width: size }} />
    );
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/components/common/Loader/Loader.js